import React from "react";
import { Col, Container, Nav, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

// Image
import alfurqanApp from "../assets/images/works/alfurqan-app.webp";
import commercialPropertyManagement from "../assets/images/works/commercial-property-management.webp";
import fabricationMobileApp from "../assets/images/works/fabrication-mobile-app.webp";
import quranQuest from "../assets/images/works/quran-quest.webp";
import restaurantManagementSystem from "../assets/images/works/restaurant-management-system.webp";
import unitySync from "../assets/images/works/unitysync.webp";
import untappedClothing from "../assets/images/works/untapped-clothing.webp";
import primoroute from "../assets/images/works/primoroute.webp";
import ecoCatalyst from "../assets/images/works/ecocatalyst.webp";

interface PortfolioData {
  image: string;
  groups: string[];
  title: string;
  category: string;
}

const portfolioData: PortfolioData[] = [
  {
    image: restaurantManagementSystem,
    groups: ["PHP", "Admin Panels"],
    title: "Meet & Cheese",
    category: "Restaurant Management System",
  },
  {
    image: unitySync,
    groups: ["PHP", "Admin Panels"],
    title: "Unity Sync",
    category: "Property Management System",
  },
  {
    image: commercialPropertyManagement,
    groups: ["Admin Panels"],
    title: "Dippie Properties",
    category: "Property Management System",
  },
  {
    image: fabricationMobileApp,
    groups: ["Mobile Apps"],
    title: "Aluminium PK",
    category: "Windows Calculation Mobile App",
  },
  {
    image: untappedClothing,
    groups: ["Mobile Apps", "Admin Panels"],
    title: "Untapped Clothing",
    category: "Ecommerce Admin Panel & Mobile App",
  },
  {
    image: quranQuest,
    groups: ["Mobile Apps", "Admin Panels"],
    title: "Quran Quest",
    category: "AlQuran Mobile App",
  },
  {
    image: alfurqanApp,
    groups: ["Mobile Apps"],
    title: "AlFurqan App",
    category: "Islamic Knowledge Mobile App",
  },
  {
    image: ecoCatalyst,
    groups: ["Mobile Apps"],
    title: "EcoCatalyst",
    category: "Sustainability-focused Mobile App",
  },
  {
    image: primoroute,
    groups: ["Admin Panels"],
    title: "Primoroute",
    category: "Smart Logistics Platform",
  },
];

const Work: React.FC = () => {
  const [filter, setFilter] = React.useState("All");

  const handleFilter = (group: any) => {
    setFilter(group);
  };

  const filteredData =
    filter === "All"
      ? portfolioData
      : portfolioData.filter((item) => item.groups.includes(filter));

  return (
    <React.Fragment>
      <section className="section portfolio business-portfolio" id="work">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6}>
              <div className="text-center">
                <h2 className="heading-title-title letter-spacing_4 text-uppercase">
                  Recent Project
                </h2>
                <p className="heading-title-desc text-muted mt-4 mb-0">
                  Here are some of the solutions we’ve delivered for clients globally — focused on performance, usability, and business impact.
                </p>
              </div>
            </Col>
            <Col lg={8}>
              <div className="filters-group-wrap mt-5 pt-3">
                <div className="filters-group">
                  <Nav className="filter-options justify-content-center">
                    <li
                      onClick={() => handleFilter("All")}
                      className={` nav-link list-inline-item mt-2  ${
                        filter === "All" ? "active" : ""
                      }`}
                      style={{ cursor: "pointer" }}
                    >
                      All
                    </li>
                    <li
                      onClick={() => handleFilter("Websites")}
                      className={`nav-link list-inline-item mt-2 ${
                        filter === "Websites" ? "active" : ""
                      }`}
                      style={{ cursor: "pointer" }}
                    >
                      Websites
                    </li>
                    <li
                      onClick={() => handleFilter("Admin Panels")}
                      className={`nav-link list-inline-item mt-2 ${
                        filter === "Admin Panels" ? "active" : ""
                      }`}
                      style={{ cursor: "pointer" }}
                    >
                      Admin Panels
                    </li>
                    <li
                      onClick={() => handleFilter("Mobile Apps")}
                      className={`nav-link list-inline-item mt-2 ${
                        filter === "Mobile Apps" ? "active" : ""
                      }`}
                      style={{ cursor: "pointer" }}
                    >
                      Mobile Apps
                    </li>
                  </Nav>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <Container className="mt-5">
          <Row id="grid">
            {(filteredData || [])?.map((item: PortfolioData, key: number) => (
              <Col
                lg={4}
                key={key}
                className="picture-item"
                data-groups={JSON.stringify(item.groups)}
              >
                <div className="gallary-box m-3 portfolio">
                  <Link className="lightbox port w-100" to="#" title="">
                    <img
                      className="gallary-container w-100 rounded-top-1"
                      style={{
                        height: "200px",
                        objectPosition: "center",
                        objectFit: "cover",
                      }}
                      loading="lazy"
                      src={item.image}
                      alt={item.title}
                    />
                    <div className="item-effect">
                      <div className="item-caption text-center bg-primary text-white p-3">
                        <h5 className="f-14 letter-spacing_2 text-uppercase mb-0">
                          {item.title}
                        </h5>
                      </div>
                    </div>
                  </Link>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Work;